const alarmStatusMap = {
  0: '正常',
  1: '预警',
  2: '报警'
};

const runClass = {
  1: 'success-color',
  2: 'warning-color',
  3: 'danger-color'
};

const runState = {
  6: '测量中',
  9: '空闲',
  29: '纸少于10%',
  30: '缺纸'
};

const alarmClassMap = {
  0: 'success-color',
  1: 'danger-color',
  2: 'danger-color'
};

export const dict = {
  alarm: alarmStatusMap,
  alarmClassMap,
  runState
};

export const tools = {
  alarmText(val) {
    return alarmStatusMap[val];
  },
  runText(val) {
    return dict.runState[val];
  },

  alarmClass(val) {
    return alarmClassMap[val];
  },
  runClass(val) {
    return runClass[val];
  }
};
